import { Copy, Paperclip, Search, SendHorizontal, X } from 'lucide-react';
import React, { useState, useRef, useEffect } from 'react';
import { Drawer } from "vaul";
import { getPractice, notify, userAccessToken } from '../../helpers';
import Spacing from '../Spacing';
import { Config } from '../../Config';

export default function ChartingHelperModal({selectedPracticeChange, fetchChangePracticeData, setShowAICharting=()=>{}}) {
  let location_id = getPractice("location_id");
  let account_id = getPractice("account_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
  }

  const [showChat, setShowChat] = useState(false);
  const [messages, setMessages] = useState([]);

  const [inputValue, setInputValue] = useState('');
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const inputRef = useRef(null);
  const messageBoxRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setShowAICharting(true);
  }, []);

  const handleSendMessage = async () => {
    const userInput = inputRef?.current?.innerText?.trim();
    if (!userInput) return;

    inputRef.current.innerText = '';
    // Add user message to chat
    setMessages((prevMessages) => [
      ...prevMessages,
      { type: "user", content: userInput },
      { type: "ai", content: "Thinking..." },
    ]);

    try {
      if (!userAccessToken()) return;
      const response = await fetch(`${Config.apiServerUrl}/ai/docflow`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
        body: JSON.stringify({
          account_id: account_id,
          location_id: location_id,
          docflow_template_id: 1,
          user_input: userInput,
          upload_files: selectedFiles,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let done = false;
      let finalResponse = "";

      while (!done) {
        const { value, done: readerDone } = await reader.read();
        done = readerDone;

        if (value) {
          const chunk = decoder.decode(value, { stream: true });
          finalResponse += chunk;

          // Update only the last AI message
          setMessages((prevMessages) => {
            const updatedMessages = [...prevMessages];
            updatedMessages[updatedMessages.length - 1] = {
              type: "ai",
              content: finalResponse,
            };
            return updatedMessages;
          });
        }
      }
      
      document.querySelectorAll('.docpro_message_item_text:last-of-type').forEach(function(element) {
        element.innerHTML = element.innerHTML.replace("```html", "").replace("```", "").replace("&lt;/<", "<");        
      });

    } catch (error) {
      console.error("Error fetching response:", error);
      setMessages((prevMessages) => [
        ...prevMessages.slice(0, -1),
        {
          type: "ai",
          content: "An error occurred while fetching the response.",
        },
      ]);
    } finally {
      setInputValue('');
      inputRef.current.innerText = '';
      setIsInputEmpty(true);
    }
  };

  const handleInput = (e) => {
    const inputElement = inputRef?.current;
    const text = inputElement?.innerText || '';
    setInputValue(text);
  };
  useEffect(() => {
    const inputElement = inputRef?.current;
    inputElement?.addEventListener('input', handleInput);
    return () => {
      inputElement?.removeEventListener('input', handleInput);
    };
  }, []);

  useEffect(() => {
    if (messageBoxRef.current) {
      messageBoxRef.current.scrollTop = messageBoxRef.current.scrollHeight;
    }
  }, [messages]);

  const handleCopy = (id) => {
    const content = document.querySelector('.GPT_response_'+id);
    const range = document.createRange();
    range.selectNode(content);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range); 
    document.execCommand('copy');
    window.getSelection().removeAllRanges();

    notify("success", "Content copied to clipboard!", 0.5);
  };

  const handleDrawerOpen = () => {
    setShowChat(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const handleDrawerClose = () => {
    setShowChat(false);
    window.scrollTo(0, previousScrollPosition);
    setMessages([]);
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <div className="docpro_chatting_wrap">
      <div style={{ height: "100%" }} ref={dropdownRef}>
        <Drawer.Root open={showChat} onOpenChange={setShowChat} onClose={handleDrawerClose}>
          <Drawer.Trigger className="docpro_chatting_btn_1 docpro_icon_btn last_btn_tip"
            onClick={handleDrawerOpen}
          >
            <img src={`${Config.appUrl}/images/ai_assistant.svg`} alt="Assistant" width={45} height={45} />
            <span className="docpro_tip">AI assistant</span>
          </Drawer.Trigger>
          <Drawer.Portal>
            <Drawer.Overlay className="docpro_drawer_overlay" />
            <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
              <Drawer.Title className="sr-only">Charting helper</Drawer.Title>
              <Drawer.Description className="sr-only">Charting create helper</Drawer.Description>
              <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">
                <div className="docpro_modal">
                  <div className={`docpro_chatting_container ${showChat ? 'active' : ''}`} style={{ height: '100%', overflowY: 'auto' }}>
                    <div className="docpro_messanger_wrap" style={{ paddingLeft: 0, height: '100%' }}>
                      <div className="">
                        <div className='docpro_data_table_headings docpro_assistant_heading_wrap'>
                          <h3 className='docpro_mb_0 docpro_fs_18 docpro_fw_600 mx-1 docpro_assistant_heading'>
                            <img src={`${Config.appUrl}/images/ai_assistant.svg`} alt="Assistant" width={28} height={28}/>
                            <span>AI Assistant</span>
                          </h3>
                        </div>
                        <div className="docpro_assistant_search">
                          <form className="docpro_search_form">
                            <input
                              type="text"
                              placeholder="Search"
                              className="docpro_search_input"
                              style={{ borderRadius: '20px' }}
                            />
                            <button className="docpro_search_btn">
                              <Search width={20} height={20} />
                            </button>
                          </form>
                        </div>
                        <hr />
                        <Spacing lg={20} sm={20} />
                        <div className='px-3'>
                          <div className='message-box assistant' style={{ marginBottom: '0' }} ref={messageBoxRef}>
                            {messages?.length > 0 ? (
                              messages.map((message, index) => (
                                <div key={index} className='docflow_chat'>            
                                  {message.type === "user" ?
                                    <div className="right-msg-data" style={{ backgroundColor: 'e9e9e954' }}>
                                      <div className={`flex-grow-3 GPT_response_${index}`} style={{ whiteSpace: 'pre-wrap', color: 'var(--primary)' }}>
                                        {message.content}
                                      </div>
                                    </div>
                                  :
                                    <div className="left-msg-data" >
                                      <div className="shoutbox-flex">
                                        <div className="docpro_message_item_avatar shoutbox_img_avatar">
                                          AI{" "}
                                        </div>
                                        <div className='relative'>
                                          <div className='docpro_message_item_text' style={{ backgroundColor: '#f6f6f6' }}>
                                            <span className={`GPT_response_${index}`} dangerouslySetInnerHTML={{ __html: message.content }} />
                                          </div>
                                          {message.content && message.content !== "Thinking..." && (
                                            <button className='absolute top-0 right-0 docpro_bordered_btn docpro_fw_600 docpro_filed_btn copy' onClick={() => handleCopy(index)}>
                                              <Copy height={16} />
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              ))
                            ) : (
                              <div className='docpro_assistant_initial'>
                                <img src={`${Config.appUrl}/images/ai_assistant.svg`} alt="Assistant" width={64} height={64}/>
                                <h3 className='docpro_fs_24'>{Config._AppName} AI Assistant</h3>
                                <p className='docpro_fs_16'>Your intelligent medical co-pilot </p>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="docpro_messanger_body_bottom">
                          <div className={`docpro_messanger_input_wrap ${selectedFiles.length === 0 && 'set_padding'}`}>
                            <div
                              className="docpro_messanger_input docpro_fs_16"
                              contentEditable="true"
                              data-placeholder="Add your message..."
                              ref={inputRef}
                              role="textbox"
                              aria-multiline="true"
                              suppressContentEditableWarning={true}
                              onInput={(e) => {
                                const value = e.currentTarget.innerText.trim();
                                setIsInputEmpty(value === '');
                              }}
                            ></div>
                            <div className='docpro_assistant_send_section'>
                              <button
                                type="button" className="docpro_icon_btn"
                                onClick={() => document.getElementById('fileInput').click()}
                              >
                                <Paperclip width={18} height={18} />
                              </button>
                              <input
                                id="fileInput"
                                type="file"
                                multiple
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                              />
                              <button
                                type='button'
                                className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn"
                                onClick={handleSendMessage}
                                disabled={isInputEmpty}
                              >
                                <SendHorizontal width={20} height={20} />
                                Send
                              </button>
                            </div>
                          </div>
                          {selectedFiles.length > 0 && (
                            <ul className="docpro_mb_0 docpro_selected_files" style={{ listStyle: 'none' }}>
                              {selectedFiles.map((file, index) => (
                                <li key={index}>
                                  <span onClick={() => handleRemoveFile(index)} className="docpro_red_color px-1 py-1" style={{ cursor: 'pointer' }}><X height={15} width={15} /></span>
                                  <span className="pl-2">{file.name}</span>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      </div>
    </div>
  );
}
